import React from "react";

function LoadingBox() {
    return (
        <div class="card loading">
            <div class="box"></div>
        </div>
    );
}

export default LoadingBox;
